import { render } from "./CentroPicker.vue?vue&type=template&id=04e0d2d2&scoped=true"
import script from "./CentroPicker.vue?vue&type=script&lang=ts"
export * from "./CentroPicker.vue?vue&type=script&lang=ts"

import "./CentroPicker.vue?vue&type=style&index=0&id=04e0d2d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04e0d2d2"

export default script